const INTELLIGENCE_APP_REFS = new Set(['ai', 'assistant-exp', 'cds-ai-service']);

export const isIntelligenceApp = (appRef, name) => {
  if (appRef && INTELLIGENCE_APP_REFS.has(appRef)) {
    return true;
  }

  const normalizedName = name?.trim?.()?.toLowerCase?.();
  if (!normalizedName) {
    return false;
  }

  if (normalizedName === 'intelligence' || normalizedName === 'command intelligence') {
    return true;
  }

  return false;
};
